module.exports = __webpack_public_path__ + "img/stock7.138a578a.png";